import React from 'react';
import PropTypes from 'prop-types';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { BellOutlined } from '@ant-design/icons';
import { Popover, Badge, Avatar, Button, Row, Col } from 'antd';
import { bindActionCreators } from 'redux'
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import notifsActions from '../../actions/notifs';
import * as notifsSelectors from '../../selectors/notifs';
import MessagesList from './MessagesList';
import './MessagesMenu.scss';
import { GlobalConfigContext } from '../Config/GlobalConfigContext';
import api from '../../middleware/api';
import { isMobile as isMobileCheck } from 'react-device-detect';
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl';
import moment from 'moment';

// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
    hidden = "hidden";
    visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}

class MessagesMenu extends React.PureComponent {
    static contextType = GlobalConfigContext;
    state = {
        totalUnread: 0,
        visible: false,
    }
    constructor(props, context) {
        super(props);
        if (isMobileCheck) {
            document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
        }
    }
    componentDidMount() {
        this.fetchTotalUnread();
        const { socket } = this.context;
		if(socket){
			socket.on('messages', this.applyMessage);
		}
    }
    componentDidUpdate = (prevProps) => {
        if(prevProps.property !== this.props.property){
            this.fetchTotalUnread();
        }
    }
    fetchTotalUnread = () => {
        api.get(`/notifications/${this.context.activeProperty.propertycode}/getTotalUnread`)
        .then(response => {
            if (response.data.success) {
                const totalUnread = response.data.total;
                //console.log(`totalUnread:`, totalUnread);
                this.setState({
                    totalUnread
                });
            }
        }).catch(error => { });
    }
    handleVisibilityChange = () => {
        if (!document[hidden]) {
            this.fetchTotalUnread();
        }else{
            this.hide();
        }
    }
    // componentWillMount(){
	// 	const { socket } = this.context;
	// 	if(socket){
	// 		socket.on('messages', this.applyMessage);
	// 	}
	// }
	componentWillUnmount(){
		const { socket } = this.context;
		if(socket){
            socket.off('messages', this.applyMessage);
		}
    }
    handleFormatting = (value, c) => {
		let date = moment(value, 'YYYY-MM-DD', true);
			if (date.isValid()) {
				return <FormattedDate value={date} year='numeric' month='short' day='2-digit' />
			} else if (c.endsWith('_amount')) {
				return <FormattedNumber value={value} style='currency' currency={this.context.currencyCode} />
			} else if (c.endsWith('_percentage')) {
				return <FormattedNumber value={value} style='percent' />
			}
			else return value;
	}
    applyMessage = (data) => {
        //console.log('applyMessage', data);
        const { notification } = data;
        //console.log(`applyMessage:`, notification);
        this.props.actions.create(this.props.instanceKey, Object.assign(notification, { tmpid: notification.id.toString() }), { isAsync: false });
        if(notification && !notification.is_read){
            this.setState(prevState => ({
				totalUnread: prevState.totalUnread + 1
			}));
        }
        // const highlightMessage = (obj) => {
        //     return Object.keys(obj).reduce((p, c) => ({...p, [c]: <b>{obj[c]}</b> }), {});
        // }
        // const highlightMessage = (obj) => {
        //     return Object.keys(obj).reduce((p, c) => ({...p, [c]: <b>{this.handleFormatting(obj[c], c)}</b> }), {});
        // }
        //const test = highlightMessage(notification.messages.message_object)
        //console.log(`test:`, test);
        //console.log(`this.context.intl:`, this.context.intl)
        this.context.notifications.notify({
            title: this.context.intl.formatMessage({ 
                id: `notifications.${notification.messages.message_types.name}`,
                defaultMessage: notification.messages.message_types.description_template,
            }, notification.messages.message_object
            ),
            //message: 'sdfsdf sdf sdf sdf ',
            type: 'notification', // 'message'
            key: `notification-${notification.id}`,
            //kind: 'info',
            options: {
                duration: 15,
                icon: <LegacyIcon type={notification.messages.message_types.icon} style={{ color:'#da342a' }}/>,
                btn: <Button onClick={() => this.viewNotification(notification)} type="primary" value={notification}>{this.context.intl.formatMessage({ id: 'messages.menu.view', defaultMessage: 'VIEW' }) }</Button>,
            }
        });

        //acknowledgmentFn(true);
    }
    viewNotification = (notification) => {
        //const notification = e.target.value;
        const { history } = this.props;
        if(notification){
            this.context.notifications.notifyClose(`notification-${notification.id}`);
            this.props.actions.update(this.props.instanceKey, { id: notification.id, is_read: 1 }, { isAsync: true }).then(() => {
                if(!notification.is_read){
                    this.handleTotalUnreadChange(-1);
                }
            });
            history.push(notification.messages.link);
        }
    }
    handleTotalUnreadChange = (value) => {
        this.setState(prevState => ({
            totalUnread: prevState.totalUnread + value
        }));
    }
    hide = () => {
        this.setState({
            visible: false,
        });
    }
    handleVisibleChange = visible => {
        this.setState({ visible });
    }
    handleMarkAll = () => {
        api.put(`/notifications/${this.context.activeProperty.propertycode}/markAll`)
        .then(response => {
            if (response.data.success) {
                this.props.actions.update(this.props.instanceKey, this.props.records.filter(record => !record.is_read).map(record => ({ id: record.id, is_read: 1 })), { isAsync: false });
                this.setState({
                    totalUnread: 0
                });
            }
        }).catch(error => { });
    }
    render() {
        const { totalUnread } = this.state;
        const title = 
            <Row>
                <Col xs={12}><FormattedMessage id="messages.menu.notifications" defaultMessage={`Notifications`} /></Col>
                <Col xs={12} className="text-right">
                    {totalUnread > 0 && <Button type="link" onClick={this.handleMarkAll}><FormattedMessage id="messages.menu.notifications.mark-all" defaultMessage={`Mark all as read`} /></Button>}
                </Col>
            </Row>;

        return (
            <Popover
                title={title}
                content={<MessagesList onReadChange={this.handleTotalUnreadChange} onHideList={this.handleVisibleChange} property={this.props.property} />}
                trigger="click"
                placement="bottomRight"
                overlayClassName="messages-overlay"
                style={{ width: this.context.isMobile ? '100%' : 500 }}
                arrowPointAtCenter
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}
            >
                <span className="messages-button">
                    <Badge count={this.state.totalUnread} overflowCount={10} >
                        <Avatar shape="circle" icon={<BellOutlined />} className="notifications-avatar" />
                    </Badge>
                </span>
            </Popover>
        );
    }
}

MessagesMenu.propTypes = {
    record: PropTypes.object,
};
MessagesMenu.defaultProps = {
    instanceKey: 'notications',
};
const mapStateToProps = (state, ownProps) => {
	const instanceKey = ownProps.instanceKey ? ownProps.instanceKey : MessagesMenu.defaultProps.instanceKey;
	const defaultProps = {
		records: notifsSelectors.fetchDataset(state, instanceKey),
	};

	return defaultProps;
}
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(notifsActions, dispatch),
	dispatch
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessagesMenu));